(function () {
  'use strict';

  function initRegionPicker(root) {
    var trigger  = root.querySelector('[data-gs-rp-trigger]');
    var panel    = root.querySelector('[data-gs-rp-panel]');
    var form     = root.querySelector('[data-gs-rp-form]');
    var inputCur = root.querySelector('[data-gs-rp-cur-input]');
    var inputLng = root.querySelector('[data-gs-rp-lng-input]');
    var saveBtn  = root.querySelector('[data-gs-rp-save]');
    var flagEl   = root.querySelector('[data-gs-rp-flag]');
    var curLabel = root.querySelector('[data-gs-rp-cur-label]');
    var lngLabel = root.querySelector('[data-gs-rp-lng-label]');

    if (!trigger || !panel) return;

    /* ── open / close ── */
    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var firstBtn = panel.querySelector('button, [tabindex]');
      if (firstBtn) firstBtn.focus();
    }
    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.hidden ? open() : close();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); trigger.focus(); }
    });

    /* ── currency row clicks ── */
    root.querySelectorAll('[data-gs-rp-currency]').forEach(function (row) {
      row.addEventListener('click', function () {
        var code = row.getAttribute('data-gs-rp-currency');
        var sym  = row.getAttribute('data-gs-rp-currency-sym');
        var rowFlagEl = row.querySelector('.gs-rp__currency-flag');

        /* update selection state */
        root.querySelectorAll('[data-gs-rp-currency]').forEach(function (r) {
          r.setAttribute('aria-current', r === row ? 'true' : 'false');
        });

        /* update hidden form input */
        if (inputCur) inputCur.value = code;

        /* update trigger display — copy inline SVG flag, not text */
        if (flagEl && rowFlagEl) flagEl.innerHTML = rowFlagEl.innerHTML;
        if (curLabel) curLabel.textContent = sym;
      });
    });

    /* ── language row clicks ── */
    root.querySelectorAll('[data-gs-rp-locale]').forEach(function (row) {
      row.addEventListener('click', function () {
        var code  = row.getAttribute('data-gs-rp-locale');
        var short = row.getAttribute('data-gs-rp-locale-short');

        root.querySelectorAll('[data-gs-rp-locale]').forEach(function (r) {
          r.setAttribute('aria-current', r === row ? 'true' : 'false');
        });

        if (inputLng) inputLng.value = code;
        if (lngLabel) lngLabel.textContent = short;
      });
    });

    /* ── save ── */
    if (saveBtn && form) {
      saveBtn.addEventListener('click', function () {
        form.submit();
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-gs-rp]').forEach(initRegionPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
